
import React, { useState } from 'react';
import { Menu, X, ShoppingCart, MapPin } from 'lucide-react';
import { cn } from '@/lib/utils';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <a href="/" className="text-2xl font-bold text-brand-black">
            عروسة عدن
          </a>
        </div>
        
        <div className="hidden md:flex items-center space-x-6 space-x-reverse">
          <a href="#about" className="text-lg hover:text-brand-pink transition-colors">
            قصتنا
          </a>
          <a href="#products" className="text-lg hover:text-brand-pink transition-colors">
            منتجاتنا
          </a>
          <a href="#location" className="text-lg hover:text-brand-pink transition-colors">
            موقعنا
          </a>
          <a href="#contact" className="text-lg hover:text-brand-pink transition-colors">
            اتصل بنا
          </a>
        </div>

        <div className="flex items-center space-x-4 space-x-reverse">
          <a 
            href="#location"
            className="p-2 rounded-full bg-brand-lightPink text-brand-pink hover:bg-brand-pink hover:text-white transition-colors"
            aria-label="Store Location"
          >
            <MapPin size={20} />
          </a>
          <a 
            href="https://www.instagram.com/arousat.aden"
            target="_blank" 
            rel="noopener noreferrer"
            className="p-2 rounded-full bg-brand-lightPink text-brand-pink hover:bg-brand-pink hover:text-white transition-colors"
            aria-label="Shopping Cart"
          >
            <ShoppingCart size={20} />
          </a>
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-full bg-brand-lightPink text-brand-pink hover:bg-brand-pink hover:text-white transition-colors"
            aria-label={isMenuOpen ? "Close Menu" : "Open Menu"}
          >
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={cn(
          "md:hidden absolute top-full left-0 right-0 bg-white shadow-md transition-all duration-300 ease-in-out", 
          isMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"
        )}
      >
        <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
          <a 
            href="#about" 
            className="text-lg py-2 border-b border-gray-100 hover:text-brand-pink transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            قصتنا
          </a>
          <a 
            href="#products" 
            className="text-lg py-2 border-b border-gray-100 hover:text-brand-pink transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            منتجاتنا
          </a>
          <a 
            href="#location" 
            className="text-lg py-2 border-b border-gray-100 hover:text-brand-pink transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            موقعنا
          </a>
          <a 
            href="#contact" 
            className="text-lg py-2 hover:text-brand-pink transition-colors"
            onClick={() => setIsMenuOpen(false)}
          >
            اتصل بنا
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
